import { render, staticRenderFns } from "./overlay-image.vue?vue&type=template&id=6a9c9369"
import script from "./overlay-image.vue?vue&type=script&lang=js"
export * from "./overlay-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports